/*
 * @Author: Teemo Ding
 * @Date: 2021-11-02 13:22:02
 * @LastEditTime: 2023-05-10 15:16:12
 * @LastEditors: Please set LastEditors
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Order/Components/OrderInfoRight/index.tsx
 */
import { useI18n } from '@/src/hooks/useRouterChange';
import { setEarliestShippingDate } from '@/src/request/order';
import { formatTimeBySetting } from '@/src/tools/helper';
import { Icon } from '@/src/tools/icon';
import { i18nGet } from '@/src/tools/tools';
import moment from 'moment';
import React from 'react';
import { useSelector } from 'react-redux';
import { SectionWrapper } from 'src/components/Layouts';
import { getBasicSetting } from 'src/constrains/GlobalProvider/slice';
import ModalHoc from 'src/constrains/ModalHOC';
import StatusTag from '../StatusTag';
import EarliestShippingDateModal from './EarliestShippingDate';
import css from './css.module.less';

const OrderInfoRight = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => {
    return i18nGet(i18n, str);
  };
  const {
    modalOp: { setShowModal, setModalTitle, setModalContent, setWidth },
    orderDetail,
    title,
    reLoadOrderPage,
  } = props;
  const {
    accessCode,
    orderUuid,
    currencyCode,
    reportingOrderTime,
    salesChannelOrderTime,
    status,
    salesChannelName,
    warehouseName,
    salesChannelTimezoneInGmt,
    reportingTimezoneInGmt,
    subTotal,
    productAmount,
    discount,
    discountAmount,
    tax,
    shipping,
    total,
    processingFee,
    salesRepresent,
    orderTimeTitle,
    firstOrderTime,
    nextOrderTime,
    frequencyText,
    earliestShippingDate,
    containPayUpFront,
  } = orderDetail;
  const format = formatTimeBySetting(useSelector(getBasicSetting()));
  const dateFormat = format.split(' ')[0];
  const onConfirm = async ({ earliestShippingDate }) => {
    const result = await setEarliestShippingDate({
      earliestShippingDate: earliestShippingDate.format('YYYY-MM-DD'),
      orderUuid: orderUuid,
    });
    if (result) {
      onCancel();
      reLoadOrderPage();
    }
  };

  const onCancel = () => {
    setShowModal(false);
    setModalContent(null);
  };

  const editEarliestShippingDate = () => {
    setWidth(600);
    setShowModal(true);
    setModalTitle(getI18n('allOrders.orderDetail.editEarliestShippingDate'));
    setModalContent(
      <EarliestShippingDateModal
        onConfirm={onConfirm}
        onCancel={onCancel}
        init={earliestShippingDate ? moment(earliestShippingDate) : null}
        format={dateFormat}
        orderUuid={orderUuid}
      />,
    );
  };
  return (
    <SectionWrapper
      title={title}
      containerClassName={css.section}
      titleClassName={css.sectionTitle}>
      {(status || []).length ? (
        <div className={css.orderItem}>
          <h3>
            {getI18n(
              'shoppingCartTemplate.shoppingCartTemplate.components_OrderInfoRight_return_orderItem',
            )}
          </h3>
          <div className={css.statusContain}>
            {(status || []).length
              ? status.map((item, index) => (
                  <StatusTag
                    key={index}
                    className={css.status}
                    status={item.status}
                    calculate={item.calculate}
                  />
                ))
              : '-'}
          </div>
        </div>
      ) : null}
      {subTotal && (
        <div className={css.orderItemFlex}>
          <h3>
            {`${getI18n(
              'shoppingCartTemplate.shoppingCartTemplate.components_OrderInfoRight_return_subtotal_orderItemFlex',
            )} ${productAmount || 0} ${getI18n('general.items')}`}
          </h3>
          <span>{subTotal}</span>
        </div>
      )}
      {discount && (
        <div className={css.orderItemFlex}>
          <h3>
            {getI18n(
              'shoppingCartTemplate.shoppingCartTemplate.components_OrderInfoRight_return_discount_orderItemFlex',
            )}
            {!!discountAmount && `(${discountAmount})`}
          </h3>
          <span>{discount}</span>
        </div>
      )}
      {(tax || []).length ? (
        <div className={css.orderItemLine}>
          <h3>
            {getI18n(
              'shoppingCartTemplate.shoppingCartTemplate.components_OrderInfoRight_return_tax_orderItemLine',
            )}
          </h3>
          {(tax || []).map((item, index) => (
            <div key={index} className={css.orderItemLineItem}>
              <span>{item.name}</span>
              <span>{item.value}</span>
            </div>
          ))}
        </div>
      ) : null}
      {(shipping || []).length ? (
        <div className={css.orderItemLine}>
          <h3>
            {getI18n(
              'shoppingCartTemplate.shoppingCartTemplate.components_OrderInfoRight_return_shipping_orderItemLine',
            )}
          </h3>
          {(shipping || []).map((item, index) => (
            <div key={index} className={css.orderItemLineItem}>
              <span>{item.name}</span>
              <span>{item.value}</span>
            </div>
          ))}
        </div>
      ) : null}
      {processingFee && (
        <div className={css.orderItemFlex}>
          <h3>
            {getI18n('shoppingCartTemplate.shoppingCartTemplate.processingFee')}
          </h3>
          <span>{processingFee}</span>
        </div>
      )}
      {total && (
        <div className={css.total}>
          <span>
            {getI18n(
              'shoppingCartTemplate.shoppingCartTemplate.components_OrderInfoRight_return_total',
            )}
          </span>
          <span>{total}</span>
        </div>
      )}
      {(reportingOrderTime || salesChannelOrderTime) && (
        <div className={css.orderItem}>
          <h3>{orderTimeTitle} </h3>
          <div className={css.timeContain}>
            <span className={css.timeTitle}>
              {getI18n(
                'shoppingCartTemplate.shoppingCartTemplate.components_OrderInfoRight_return_report_time',
              )}
            </span>
            <div>
              {reportingOrderTime} (GMT {reportingTimezoneInGmt})
            </div>
          </div>
          <div className={css.timeContain}>
            <span className={css.timeTitle}>
              {getI18n(
                'shoppingCartTemplate.shoppingCartTemplate.components_OrderInfoRight_return_saleschannel_time',
              )}
            </span>
            <div>
              {salesChannelOrderTime} (GMT {salesChannelTimezoneInGmt})
            </div>
          </div>
        </div>
      )}
      {firstOrderTime && (
        <div className={css.orderItem}>
          <h3>
            {getI18n(
              'shoppingCartTemplate.shoppingCartTemplate.components_OrderInfoRight_return_firstorder_time',
            )}
          </h3>
          <span>
            {firstOrderTime} (GMT {salesChannelTimezoneInGmt})
          </span>
        </div>
      )}
      {nextOrderTime && (
        <div className={css.orderItem}>
          <h3>
            {getI18n(
              'shoppingCartTemplate.shoppingCartTemplate.components_OrderInfoRight_return_nextorder_time',
            )}
          </h3>
          <span>
            {nextOrderTime} (GMT {salesChannelTimezoneInGmt})
          </span>
        </div>
      )}
      {salesRepresent && (
        <div className={css.orderItem}>
          <h3>
            {getI18n(
              'shoppingCartTemplate.shoppingCartTemplate.components_OrderInfoRight_return_sales_represent',
            )}
          </h3>
          <span>{salesRepresent}</span>
        </div>
      )}
      {accessCode && (
        <div className={css.orderItem}>
          <h3>
            {getI18n('shoppingCartTemplate.shoppingCartTemplate.accessCode')}
          </h3>
          <span>{accessCode}</span>
        </div>
      )}
      {salesChannelName && (
        <div className={css.orderItem}>
          <h3>
            {getI18n(
              'shoppingCartTemplate.shoppingCartTemplate.components_OrderInfoRight_return_Sales_Channel',
            )}
          </h3>
          <span>{salesChannelName}</span>
        </div>
      )}
      {currencyCode && (
        <div className={css.orderItem}>
          <h3>
            {getI18n(
              'shoppingCartTemplate.shoppingCartTemplate.components_OrderInfoRight_return_Currency',
            )}
          </h3>
          <span>{currencyCode}</span>
        </div>
      )}
      {warehouseName && (
        <div className={css.orderItem}>
          <h3>
            {getI18n(
              'shoppingCartTemplate.shoppingCartTemplate.components_OrderInfoRight_return_Warehouse',
            )}
          </h3>
          <span>{warehouseName}</span>
        </div>
      )}
      {frequencyText && (
        <div className={css.orderItem}>
          <h3>
            {getI18n(
              'shoppingCartTemplate.shoppingCartTemplate.components_OrderInfoRight_return_sub_buy',
            )}
          </h3>
          <span>{frequencyText}</span>
        </div>
      )}
      {containPayUpFront || earliestShippingDate ? (
        <div className={css.orderItem}>
          <h3>
            {getI18n('allOrders.orderDetail.earliestShippingDate') ||
              'Earliest Shipping Date'}
            {containPayUpFront && (
              <Icon onClick={editEarliestShippingDate} type='iconedit' />
            )}
          </h3>
          <span>
            {earliestShippingDate
              ? moment(earliestShippingDate).format(dateFormat)
              : '-'}
          </span>
        </div>
      ) : null}
    </SectionWrapper>
  );
};
export default ModalHoc(OrderInfoRight);
